import { FC } from 'react';

import { useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import { useSelector } from 'src/hooks/useSelector';

import ContextBannerWithVacancy from 'src/components/Search/Resume/ContextVacancy/Banner/WithVacancy';
import ContextBannerWithoutVacancy from 'src/components/Search/Resume/ContextVacancy/Banner/WithoutVacancy';

const ResumeSearchContextBanner: FC = () => {
    const contextVacancy = useSelector((state) => state.resumeSearchContext?.vacancy);

    const employerId = useSelector((state) => state.employerId);
    const employerManagerId = useSelector((state) => state.employerManager?.id) || '';

    const { isMobile } = useBreakpoint();

    return (
        <>
            {contextVacancy ? (
                <ContextBannerWithVacancy
                    vacancyName={contextVacancy.name}
                    vacancyId={contextVacancy.id}
                    filters={contextVacancy.filters}
                    employerId={employerId}
                    employerManagerId={employerManagerId}
                    isMobile={isMobile}
                />
            ) : (
                <ContextBannerWithoutVacancy
                    employerId={employerId}
                    employerManagerId={employerManagerId}
                    isMobile={isMobile}
                />
            )}
            <VSpacing default={16} />
        </>
    );
};

export default ResumeSearchContextBanner;
